import waitForElementUtil from "./waitForElementUtil.util.js";
// wait for an element to appear in the DOM with a delay
// after it is found due to its animation or transition
export const waitForElementWithDelayUtil = async ({ selector, delayAfterFound = 200, checkVisibility = false, }) => {
    const element = await waitForElementUtil({ selector, checkVisibility });
    if (delayAfterFound > 0) {
        await new Promise((resolve) => setTimeout(resolve, delayAfterFound)); // Add delay
    }
    return element;
};
export default waitForElementWithDelayUtil;
